import { playSound, playSoundUntilFinished } from '@/src/utils/soundPlayer'

export function playCharacterTunnelEnterSound(): void {
    playSound('characterTunnelEnter')
}

export function playCharacterPlaneSoundAfterCollect(): void {
    playSound('powerUpCollect')
    setTimeout(() => {
        playSound('characterPlane')
    }, 500)
}

export function playCharacterLightningSoundAfterActivate(): void {
    void playSoundUntilFinished('batteryActivate').then(() => {
        playSound('characterLightning')
    })
}

export function playCharacterHeartCollectSoundAfterCollect(): void {
    playSound('heartCollect')
    setTimeout(() => {
        playSound('characterHeartCollect')
    }, 500)
}

export function playCharacterStretchSound(): void {
    playSound('characterStretch')
}

// export function playCharacterFinishLineSounds(): void {
//     playSound('characterFinishLine')
//     window.setTimeout(() => {
//         playSound('characterFinishCardJump')
//     }, FINISH_CARD_JUMP_DELAY_MS)
// }
